import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext.jsx';
import { Spinner } from '../components/ui';

/**
 * Gate for everything under /app.
 *
 * While the stored token is being revalidated we show a spinner rather than
 * bouncing to login — otherwise every refresh would flash the login screen.
 * Once signed out, we remember where the user was headed so they land there
 * after signing in.
 */
export function RequireAuth({ children }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
        <Spinner label="Checking your session" />
      </div>
    );
  }

  if (status !== 'signed-in') {
    return <Navigate to="/app/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}
